import React, { useEffect, useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import { getApiClient } from "../../server/get_api_client";
import styled from "styled-components";
import { useScreenWidth } from "../../helper/screentWidth";

function NonTrainingPrograms({
  Title = "Fellowship",
  Active = true,
  value,
  onChange,
  textValue,
  onTextChange,
  isCustom = false,
  onCustomToggle,
  valueName,
}) {
  const [data, setData] = useState([]);
  const [name, setName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [displayOptions, setDisplayOptions] = useState([]);
  const screenWidth = useScreenWidth();

  useEffect(() => {
    getApiClient()
      .getNonTrainingProgram()
      .then((res) => {
        if (res.data) {
          const options = res.data.map((item) => ({
            key: item.accountid,
            value: item.accountid,
            text: item.name,
          }));
          setData(options);
          setDisplayOptions(options);
        }
      })
      .catch((error) => console.error("API Error:", error));
  }, []);

  // useEffect(() => {
  //   if (!isCustom && data.length > 0) {
  //     const selectedOption = data.find((item) => item.value === value);
  //     if (selectedOption) {
  //       setName(selectedOption.text);
  //     } else {
  //       setName(valueName);
  //     }
  //   } else if (isCustom) {
  //     setName(textValue || "");
  //   } else {
  //     setName("");
  //   }
  // }, [value, data, isCustom, textValue]);

  // Update display options based on search
  useEffect(() => {
    if (!searchQuery.trim()) {
      setDisplayOptions(data);
    } else {
      const filtered = data.filter((option) =>
        option.text.toLowerCase().includes(searchQuery.toLowerCase())
      );
      
      // If no results found and we have a search query, add create option
      if (filtered.length === 0 && searchQuery.trim() && Active) {
        setDisplayOptions([
          {
            key: 'create-new',
            value: 'create-new',
            text: `Create "${searchQuery}"`,
            content: (
              <CreateOptionContent>
                <CreateIcon>+</CreateIcon>
                Create "{searchQuery}"
              </CreateOptionContent>
            )
          }
        ]);
      } else {
        setDisplayOptions(filtered);
      }
    }
  }, [searchQuery, data, Active]);

  // Handle search change
  const handleSearchChange = (event, { searchQuery: query }) => {
    setSearchQuery(query || "");
  };

  // Called when dropdown selection changes
  const handleChange = (event, dropdownData) => {
    // Check if user selected the create option
    if (dropdownData.value === 'create-new') {
      if (onCustomToggle && onTextChange) {
        onCustomToggle(true);
        onTextChange(searchQuery);
        onChange(null);
      }
      return;
    }

    onChange(dropdownData.value);

    const selectedOption = dropdownData.options.find(
      (option) => option.value === dropdownData.value
    );
    if (selectedOption) {
      setName(selectedOption.text);
    }
  };

  const handleTextChange = (newValue) => {
    // Auto-switch back to dropdown when user starts typing
    if (newValue && newValue.length > 0 && onCustomToggle) {
      onCustomToggle(false);
      setSearchQuery(newValue);
      if (onTextChange) {
        onTextChange("");
      }
      return;
    }
    
    if (onTextChange) {
      onTextChange(newValue);
    }
  };

  return (
    <Container>
      <FieldName>{Title}</FieldName>
        <>
          {!isCustom ? (
            <DropdownWrapper>
              <CustomDropDown
                placeholder="Select company/group"
                fluid
                search
                selection
                disabled={!Active}
                onChange={handleChange}
                onSearchChange={handleSearchChange}
                value={value}
                options={displayOptions}
                text={valueName && !data.find(item => item.value === value) ? valueName : undefined}
                noResultsMessage=""
              />
              <SearchIcon name="search" />
            </DropdownWrapper>
          ) : (
            <CustomContainer>
              <CustomTextField
                Active={Active}
                Title=""
                value={textValue || ""}
                onChange={handleTextChange}
                placeholder="Enter company/group name"
              />
            </CustomContainer>
          )}
        </>
      
    </Container>
  );
}

// Styled components
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr ;
  align-items: center;
  width: 100%;
  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
    max-height: 100px;
  }
`;


const FieldName = styled.div`
  text-align: right;
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;
  @media screen and (max-width: ${(props) =>
      props.firstmeeting ? "983px" : "690px"}) {
    padding: 20px 0px 0px 0px;
  }
`;

const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  min-width: 120px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;

  height: 36px;
`;

const CustomDropDown = styled(Dropdown)`
  background: var(--editable) !important;
  border: none !important;

  .dropdown.icon {
    display: none !important;
  }
&.ui.selection.dropdown {
    min-height: 30px !important;
    border-radius: 20px !important;
    padding: 0 35px 0 10px !important; /* Match padding-left: 10px */
    line-height: 30px !important;
    
    color: #304961 !important;
    font-family: "Museo Sans Cyrl" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border: none !important;
    outline: none !important;
  }
  /* Style the create option */
  .menu > .item[data-value="create-new"] {
    background-color: #f8f9fa !important;
    border-top: 1px solid #e9ecef !important;
    color: #87a9bf !important;
    font-weight: 500 !important;
  }

  .menu > .item[data-value="create-new"]:hover {
    background-color: #87a9bf !important;
    color: white !important;
  }
`;

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SearchIcon = styled(Icon)`
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: #304961 !important;
  pointer-events: none !important;
`;

const CustomContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

const CreateOptionContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #87a9bf;
  font-weight: 500;
`;

const CreateIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #87a9bf;
  color: white;
  font-size: 12px;
  font-weight: bold;
`;

// Import CustomTextField component
const CustomTextField = ({ Active, Title, value, onChange, placeholder }) => {
  return (
    <TextFieldWrapper>
      <StyledInput
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={!Active}
      />
    </TextFieldWrapper>
  );
};

const TextFieldWrapper = styled.div`
  flex: 1;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  background: var(--editable);
  
  &:focus {
    outline: none;
    border-color: #87a9bf;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export default NonTrainingPrograms;
